import Button, { ButtonProps } from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { forwardRef, PropsWithChildren } from 'react';
import { RetryIcon } from '../../icons';

export type LoadingButtonProps = ButtonProps & {
  loading: boolean;
  error?: boolean;
  errorIcon?: React.ReactNode;
  wheelColor?: 'primary' | 'secondary' | 'inherit';
  to?: string;
};

const LoadingButton = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<LoadingButtonProps>
>(
  (
    {
      loading,
      disabled,
      error = false,
      errorIcon,
      wheelColor = 'inherit',
      children,
      ...props
    },
    ref
  ) => (
    <Button
      {...props}
      ref={ref}
      color={error && !loading ? 'error' : props.color}
      disabled={loading || disabled}
      sx={{ position: 'relative', ...props.sx }}
      startIcon={
        error && !loading ? (errorIcon ?? <RetryIcon />) : props.startIcon
      }
    >
      {loading && (
        <CircularProgress
          className="circular-progress-loading"
          sx={{
            position: 'absolute',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          color={wheelColor}
        />
      )}
      <span style={{ visibility: loading ? 'hidden' : 'visible' }}>
        {children}
      </span>
    </Button>
  )
);

LoadingButton.displayName = 'LoadingButton';

export default LoadingButton;
